var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/nav/\\u0438\\u0441\\u0442\\u043E\\u0440\\u0438\\u044F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,9.75 L17.169,9.75 C16.9328941,9.74903346 16.7066346,9.65790114 16.539,9.49625 L15.261,8.25375 C15.0933654,8.09209886 14.8671059,8.00096654 14.631,8 L7.8,8 C6.80588745,8 6,8.78350169 6,9.75 L6,20.25 C6,21.2164983 6.80588745,22 7.8,22 L22.2,22 C23.1941125,22 24,21.2164983 24,20.25 L24,11.5 C24,10.5335017 23.1941125,9.75 22.2,9.75 Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.92cddcac.svg";
export { ForwardRef as ReactComponent };